export default __webpack_public_path__ + "static/media/secondstepsm.e33da1b9.png";